module.exports = __webpack_public_path__ + "img/Delete-circle.0ec45428.svg";